import { render, staticRenderFns } from "./CompanyRegistryContactTable.vue?vue&type=template&id=d40f6d60&"
import script from "./CompanyRegistryContactTable.vue?vue&type=script&lang=js&"
export * from "./CompanyRegistryContactTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports